import { Box, Divider, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locale'
import { OrderClientDto, ReceiptDto } from 'service-api/src/types/api'
import { buildDepositInvoices, getDepositPolicyType, getDescription, getTitle, PaymentPolicyEntry } from './helper'

export interface DepositPolicyCardProps {
  order: OrderClientDto
  receipt: ReceiptDto
}

export const DepositPolicyCard = ({ order, receipt }: DepositPolicyCardProps) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  // paymentPolicies is always present — legacy orders are converted via resolveOrderData
  const paymentPolicies = (order.data as unknown as { paymentPolicies: Record<string, PaymentPolicyEntry> })
    .paymentPolicies
  // refundPolicyV2 always has entries when paymentPolicies exists on the order
  const invoices = buildDepositInvoices(order, receipt)

  const type = getDepositPolicyType(paymentPolicies)
  const title = getTitle(type)
  const description = getDescription(type)

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px`,
      }}
    >
      <Typography variant="h5">{title}</Typography>
      {description && <Typography sx={{ mt: 1 }}>{description}</Typography>}
      <Stack mt={2}>
        {invoices.map((invoice, idx) => (
          <Box key={invoice.invoiceId}>
            {idx > 0 && <Divider sx={{ my: 2 }} />}
            <Typography variant="body1bold">
              {invoice.serviceName} - {invoice.startDate}
            </Typography>
            <Box sx={{ fontSize: 14, mt: 0.5, mb: 2 }} dangerouslySetInnerHTML={{ __html: invoice.depositLine }} />
            <Typography variant="body1bold">{t('depositPolicy.cancellationsAndRefunds')}</Typography>
            <Stack spacing={0.5} mt={0.5}>
              {invoice.refundLines.map((line, lineIdx) => (
                <Box key={lineIdx} sx={{ fontSize: 14 }} dangerouslySetInnerHTML={{ __html: line }} />
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Paper>
  )
}
